import React from 'react';
import { inject, observer } from 'mobx-react';

import SingleButton, { getClassName, getDisabledClassName } from '@/components/SingleButton';
import Msg from '@/components/Msg';
import classnames from 'classnames';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { DIALOGUE_FROM, DIALOGUE_TYPE, TrackerProps, TrackerClickData } from '@/types/common';
import AgentStore from '@/stores/agent';
import { tracker } from '@/utils/tracking';

import { queueFilterCancelQueue, queueFilterContinueQueue } from '@/utils/agent';
import './style.scss';

const PREFIX = 'options-container';
interface IOptions {
  content: string;
  onClick: () => void;
  disabledBtn?: boolean;
  disabledText: boolean;
  style?: { key: string };
  clickTracker?: TrackerClickData;
  restoreClickKey?: string;
}

enum ShowType {
  horizontal = 'horizontal',
  vertical = 'vertical'
}

interface ICustomOptionsProps extends TrackerProps{
  isHistory: boolean;
  type: ShowType;
  passedRef: any;
  disabledBtn: boolean;
  isLastMessage: boolean;
  title: string;
  options: IOptions[];
  agentStore: typeof AgentStore;
  impressionTracker: any;
}


const RESTORE_CLICK_FUNCTION_MAP = {
  queueFilterCancelQueue,
  queueFilterContinueQueue,
};

@inject(getChildInject('agentStore'))
@observer
class CustomOptions extends React.PureComponent<ICustomOptionsProps> {
  static defaultProps = {
    // props
    isHistory: false,
    type: ShowType.vertical,
    passedRef: () => {},
    disabledBtn: false,
    title: '',
    options: [],
    impressionTracker: {},
  };

  constructor(props: ICustomOptionsProps) {
    super(props);
  }

  handleOptionClick = (option: IOptions) => () => {
    const { agentStore } = this.props;
    const { onClick, content = '', disabledText = false, clickTracker, restoreClickKey } = option;
    if (!disabledText) {
      agentStore.ADD_AGENT_DATA_ITEM({
        from: DIALOGUE_FROM.USER,
        type: DIALOGUE_TYPE.Msg,
        data: { content },
        _useAfterDialogueShow_: true,
      });
    }
    if (typeof onClick === 'function') {
      onClick();
    } else if (restoreClickKey) {
      const restoreFunction = RESTORE_CLICK_FUNCTION_MAP[restoreClickKey as keyof typeof RESTORE_CLICK_FUNCTION_MAP];
      typeof restoreFunction === 'function' && restoreFunction();
    }

    if (clickTracker) {
      this.props.tracker.click(clickTracker);
    }
  };


  generateOption = (option: IOptions, index: number) => {
    const { disabledBtn = false, isLastMessage = false } = this.props;
    const { content = '' } = option;
    const isDisabledBtn = disabledBtn || !isLastMessage;
    const className = isDisabledBtn ? getDisabledClassName(option.style) : getClassName(option.style);
    const props = {
      className: classnames('option-container', className),
      key: `option-${index}`,
      text: content,
      handleClick: isDisabledBtn ? () => {} : this.handleOptionClick(option),
      disabled: isDisabledBtn,
    };

    return <SingleButton {...props} />;
  };


  render() {
    const { title, options, type, impressionTracker, isHistory, passedRef } = this.props;
    let classNames = PREFIX;

    if (type === 'horizontal') {
      classNames += ' horizontal';
    }

    const trackingProps = impressionTracker ? {
      'data-trackingname': impressionTracker?.trackingname,
      'data-trackingpage': impressionTracker?.page,
      'data-trackingdata': JSON.stringify({ ...(impressionTracker?.data || {}) }),
    } : {};

    return (
      <div
        ref={isHistory ? null : passedRef}
        className={classNames}
        {...trackingProps}
      >
        <Msg content={title} />
        <div className="options">
          {options.map((option, index) => {
            return this.generateOption(option, index);
          })}
        </div>
      </div>
    );
  }
}

export default tracker(CustomOptions);
